export const flowElementTypes = {
  TASK: 'task',
  CONDITION: 'condition',
  START: 'start',
  END: 'end'
}
